import {
  prescriptionRegistrationDeadlineService,
  type CreatePrescriptionRegistrationDeadlineRequest,
} from '@/entities/prescription/api/prescription-registration-deadline.api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const prescriptionDeadlineKeys = {
  all: ['prescription-registration-deadlines'] as const,
  list: (year: number) => [...prescriptionDeadlineKeys.all, year] as const,
};

export const usePrescriptionRegistrationDeadlines = (year: number) =>
  useQuery({
    queryKey: prescriptionDeadlineKeys.list(year),
    queryFn: () => prescriptionRegistrationDeadlineService.list(year),
  });

/**
 * 추가·수정·삭제를 한 훅으로 묶는다.
 * 어느 쪽이든 성공하면 editable/deletable 플래그가 바뀌므로 목록을 다시 받는다.
 */
export const usePrescriptionRegistrationDeadlineMutations = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: prescriptionDeadlineKeys.all });

  const create = useMutation({
    mutationFn: (body: CreatePrescriptionRegistrationDeadlineRequest) =>
      prescriptionRegistrationDeadlineService.create(body),
    onSuccess: invalidate,
  });

  const update = useMutation({
    mutationFn: ({
      yearMonth,
      deadlineDate,
    }: CreatePrescriptionRegistrationDeadlineRequest) =>
      prescriptionRegistrationDeadlineService.update(yearMonth, deadlineDate),
    onSuccess: invalidate,
  });

  const remove = useMutation({
    mutationFn: (yearMonth: string) =>
      prescriptionRegistrationDeadlineService.remove(yearMonth),
    onSuccess: invalidate,
  });

  return { create, update, remove };
};
